class CollectionTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = this.querySelectorAll('[role="tab"]');
    this.panels = this.querySelectorAll('[role="tabpanel"]');
    this.tabs.forEach((t) => {
      t.addEventListener('click', (e) => {
        this.activate(e.currentTarget);
      });
      t.addEventListener('keydown', (e) => {
        var idx = Array.prototype.indexOf.call(this.tabs, e.currentTarget);
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.activate(this.tabs[(idx + 1) % this.tabs.length]);
          this.tabs[(idx + 1) % this.tabs.length].focus();
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.activate(this.tabs[(idx - 1 + this.tabs.length) % this.tabs.length]);
          this.tabs[(idx - 1 + this.tabs.length) % this.tabs.length].focus();
        }
      });
    });
    var current = Array.from(this.tabs).find((t) => t.getAttribute('aria-selected') === 'true');
    if (!current && this.tabs.length) {
      this.activate(this.tabs[0]);
    } else if (current) {
      this.activate(current);
    }
  }
  activate(tab) {
    this.tabs.forEach((t) => {
      t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
      if (t === tab) {
        t.classList.add('active');
      } else {
        t.classList.remove('active');
      }
    });
    var target = tab.getAttribute('data-panel');
    this.panels.forEach((p) => {
      p.hidden = p.id !== target;
    });
  }
}
customElements.define('collection-tabs', CollectionTabs);
